import React, { useEffect, createElement } from 'react';
import Index from './pages/Index';
import { initMetaPixel } from './utils/metaPixel';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/wW6s9hVDQ2XFmRGN8Pyfyo/COLECCION_COMPLETA.webp';
/**
 * Inject Google Fonts via <link> tags (non-render-blocking) and preload the hero image
 * to improve LCP on mobile. Replaces the @import url() in index.css which was blocking
 * the critical render path by ~2.1s.
 */
function injectCriticalAssets() {
  if (typeof document === 'undefined') return;
  if ((window as any).__criticalAssetsInjected) return;
  (window as any).__criticalAssetsInjected = true;
  const head = document.head;
  // Preconnect to Google Fonts origins for faster handshake
  const pc1 = document.createElement('link');
  pc1.rel = 'preconnect';
  pc1.href = 'https://fonts.googleapis.com';
  head.appendChild(pc1);
  const pc2 = document.createElement('link');
  pc2.rel = 'preconnect';
  pc2.href = 'https://fonts.gstatic.com';
  pc2.crossOrigin = 'anonymous';
  head.appendChild(pc2);
  // Slimmed font payload: down from 12 files to ~8 (kept only weights actually used)
  const fontUrl = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Nunito:wght@700;800;900&family=Playfair+Display:ital,wght@1,600&display=swap';
  // Trick to load CSS non-render-blocking: rel=preload then swap to stylesheet
  const fontLink = document.createElement('link');
  fontLink.rel = 'preload';
  fontLink.as = 'style';
  fontLink.href = fontUrl;
  fontLink.onload = function () {
    ;
    (this as HTMLLinkElement).rel = 'stylesheet';
  };
  head.appendChild(fontLink);
  // Fallback in case preload trick is blocked
  const noscriptFallback = document.createElement('noscript');
  const fallbackLink = document.createElement('link');
  fallbackLink.rel = 'stylesheet';
  fallbackLink.href = fontUrl;
  noscriptFallback.appendChild(fallbackLink);
  head.appendChild(noscriptFallback);
  // Preload hero image to win LCP race
  const heroPreload = document.createElement('link');
  heroPreload.rel = 'preload';
  heroPreload.as = 'image';
  heroPreload.href = HERO_IMG;
  (heroPreload as any).fetchPriority = 'high';
  head.appendChild(heroPreload);
}
// Run as early as possible (before React mounts) for max LCP impact
if (typeof window !== 'undefined') {
  injectCriticalAssets();
}
export function App() {
  useEffect(() => {
    // Safety net if the eager call above was skipped
    injectCriticalAssets();
    try {
      initMetaPixel();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('[App] Meta Pixel init skipped:', err);
    }
  }, []);
  return <Index data-id="element-0" />;
}